import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FinancialAsset } from '@app/models/project.models';
import {
  FinancialAssetConnectionToProjectType,
  FinancialAssetType,
} from '@app/models/shared.enums';
import { v4 as uuidv4 } from 'uuid';

export interface FinancialAssetFormData {
  id: string;
  type: FinancialAssetType;
  projectConnectionType: FinancialAssetConnectionToProjectType;
  nominalInterestRate: number | null;
  startOfPayingInterest: Date | null;
  interestPaymentFrequenty: number | null;
  dateOfExpiration: Date | null;
  applicableYield: number | null;
}

export interface FinancialAssetFormGroup {
  id: FormControl<string>;
  type: FormControl<FinancialAssetType>;
  projectConnectionType: FormControl<FinancialAssetConnectionToProjectType>;
  nominalInterestRate: FormControl<number | null>;
  startOfPayingInterest: FormControl<Date | null>;
  interestPaymentFrequenty: FormControl<number | null>;
  dateOfExpiration: FormControl<Date | null>;
  applicableYield: FormControl<number | null>;
}

export function getFinancialAssetFormGroup(
  fb: FormBuilder,
  type: FinancialAssetType,
  projectConnectionType: FinancialAssetConnectionToProjectType
): FormGroup<FinancialAssetFormGroup> {
  return fb.nonNullable.group({
    id: fb.nonNullable.control<string>(uuidv4()),
    type: fb.nonNullable.control<FinancialAssetType>(type),
    projectConnectionType:
      fb.nonNullable.control<FinancialAssetConnectionToProjectType>(
        projectConnectionType
      ),
    nominalInterestRate: fb.control<number | null>(null),
    startOfPayingInterest: fb.control<Date | null>(null),
    interestPaymentFrequenty: fb.control<number | null>(null),
    dateOfExpiration: fb.control<Date | null>(null),
    applicableYield: fb.control<number | null>(null),
  });
}

export function getFinancialAssetFormDataFromFinancialAsset(
  financialAssets: FinancialAsset | null,
  type: FinancialAssetType,
  projectConnectionType: FinancialAssetConnectionToProjectType
): FinancialAssetFormData {
  return {
    id: uuidv4(),
    type: type,
    projectConnectionType: projectConnectionType,
    nominalInterestRate:
      financialAssets === null ? null : financialAssets.interestRate,
    startOfPayingInterest:
      financialAssets === null ? null : financialAssets.start,
    interestPaymentFrequenty:
      financialAssets === null ? null : financialAssets.payFrequency,
    dateOfExpiration: financialAssets === null ? null : financialAssets.end,
    applicableYield:
      financialAssets === null ? null : financialAssets.applicableReturn,
  };
}
